import styles from "components/sections/searchSection.module.scss";
import topBarStyles from "components/layout/TopBar/topBar.module.scss";
import classNames from "classnames";
import Search from "components/layout/TopBar/Search";
import ArrowBackIcon from "images/icons/arrow_back.svg";
import {useContext, useRef, useState, useEffect} from "react";
import 'swiper/css';
import "swiper/css/pagination";
import "swiper/css/navigation";
import SearchResult, {KEY_ALL, KEY_STORE, KEY_TO_TAB_NAME} from "components/sections/search/SearchResult";
import ScrollPreventer from "common/ScrollPreventer";
import {Axios} from "api";
import TopTabBar from "components/TopTabBar";
import UserContext from "context/AuthContext";
import {captureException, captureMessage} from "@sentry/nextjs";
import {useRouter} from "next/router";
import useTranslation from "next-translate/useTranslation";

export const SearchSectionComponentId = 'search-section';
export const SearchQueryLocalStorageKey = 'search-queries';

const SearchSection = (props) => {
    const {isOpen, setIsOpen} = props;
    const shouldResetTextRef = useRef(false);
    const [isLoading, setIsLoading] = useState(false);

    const sectionRef = useRef(null);
    const user = useContext(UserContext).user;

    const router = useRouter();
    const reset = () => {
        shouldResetTextRef.current = true;
        setIsLoading(false);
    };
    useEffect(() => {
        if (isOpen) {
            typeof mixpanel !== 'undefined' && mixpanel.track("SearchSectionOpen");
        } else {
            typeof mixpanel !== 'undefined' && mixpanel.track("SearchSectionClose");
            if (shouldResetTextRef.current) {
                shouldResetTextRef.current = false;
            }
        }
    }, [isOpen]);

    const close = () => {
        router.back();
        typeof mixpanel !== 'undefined' && mixpanel.track("SearchSectionCloseButtonClick");
        reset();
    };

    const handlePopState = () => {
        if (isOpen) {
            reset();
        }
    };

    useEffect(() => {
        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [isOpen]);

    const setSearchText = (searchText) => {
        const prevQuery = router.query;
        const query = searchText && searchText !== '' ?
            Object.assign({}, prevQuery, {q: searchText}) :
            {tab: prevQuery.tab, q: ''};

        console.log('setSearchText', query, searchText, prevQuery);

        router.replace(
            {query: query},
            undefined,
            {
                shallow: true,
                scroll: false,
            }
        );
    };

    const searchText = router.query?.q || '';

    const setActiveTab = (activeTab) => {
        const query = {tab: activeTab, q: searchText};
        if (activeTab === KEY_STORE) {
            query['phase'] = 2;
        }
        router.push(
            {query},
            undefined,
            {
                shallow: true,
                scroll: false,
            }
        );
    };

    const activeTab = router.query?.tab || KEY_ALL;

    const recordSearchQuery = async (query) => {
        try {
            let res = await Axios.post(`v1/search/stats`, {query})
            if (res.status < 400) {
                if (!user) {
                    const queries = JSON.parse(window.localStorage.getItem(SearchQueryLocalStorageKey)) || [];
                    const newQueries = [query, ...queries.filter(item => item !== query)].slice(0, 10);
                    window.localStorage.setItem(SearchQueryLocalStorageKey, JSON.stringify(newQueries));
                }
            } else {
                captureMessage(JSON.stringify(res.data));
            }
        } catch (e) {
            captureException(e);
        } finally {
        }
    };

    const scrollResultToTop = () => {
        const target = document.getElementById(SearchSectionComponentId);
        if (target) {
            target.scrollTop = 0;
        }
    };

    const handleSetSearchText = (query) => {
        setSearchText(query);
        recordSearchQuery(query);
        scrollResultToTop();
    };

    const onTabClick = (tab) => {
        setActiveTab(tab);
        scrollResultToTop();
        typeof mixpanel !== 'undefined' && mixpanel.track(
            "SearchSectionTabClick", {tab}
        );
    };
    const {t} = useTranslation('components-sections-SearchSection');
    return (
        <>
            <div id={SearchSectionComponentId} ref={sectionRef} className={styles.mobileSearchPage}
                 style={{visibility: !isOpen ? 'hidden' : 'visible'}}>
                <div className={classNames(topBarStyles.topBar, styles.titleBar)}>
                    <div className={styles.titleRow}>
                        <ArrowBackIcon className={styles.backIcon} onClick={close}/>
                        <div className={classNames(styles.searchBarContainer)}>
                            <Search
                                searchText={searchText} setSearchText={setSearchText}
                                onSubmit={recordSearchQuery} autoFocus
                            />
                        </div>
                    </div>
                    <div className={styles.topBarWrapper}>
                        <TopTabBar
                            isLoading={isLoading}
                            activeRoute={activeTab}
                            tabs={Object.entries(KEY_TO_TAB_NAME).map(([key, value]) => ({
                                route: key,
                                title: t(`tab.${value}`),
                                onClick: () => {
                                    onTabClick(key);
                                }
                            }))}
                            height={42}
                        />
                    </div>
                </div>
                <SearchResult
                    searchText={searchText} setSearchText={handleSetSearchText}
                    activeTab={activeTab} setActiveTab={setActiveTab}
                    close={() => {
                        setIsOpen(false);
                    }}
                />
            </div>
        </>
    )
}

export default SearchSection;
